import React from 'react';
import {Modal, Button, Alert} from 'react-bootstrap';
import accountManagement from '../../apis/accountManagement';
import {newRecoveryRequestId, submitRecovery, checkRecovery, recoveryFailure, recoveryReloadRequired} from '../../apis/studentPasswordRecovery';

export class StudentPasswordRecovery extends React.Component {
  state = {open:false, requestId:null, pending:false, message:'', password:null, receipt:null, visible:false, uncertain:false, reloadRequired:false};
  componentWillUnmount() {
    this._unmounted = true; clearTimeout(this._hideTimer);
    this.state = {...this.state, password:null, receipt:null, requestId:null};
  }
  open = () => {
    if (this._pending || this.state.open) return;
    try {
      this.setState({open:true, requestId:newRecoveryRequestId(), pending:false, message:this.state.reloadRequired ? 'Muat ulang halaman sebelum melanjutkan. Belum ada perubahan data.' : '', password:null, receipt:null, visible:false, uncertain:false, reloadRequired:this.state.reloadRequired});
    } catch (error) { this.setState({open:true, message:'Peramban tidak mendukung pemulihan aman. Gunakan peramban terbaru.'}); }
  };
  close = () => {
    if (this._pending) return;
    clearTimeout(this._hideTimer);
    this.setState({open:false, requestId:null, password:null, receipt:null, visible:false, message:'', uncertain:false});
  };
  create = async () => {
    if (this._pending || !this.state.requestId || this.state.uncertain || this.state.receipt || this.state.reloadRequired) return;
    this._pending = true; this.setState({pending:true, message:'', password:null, visible:false});
    try {
      const receipt = await submitRecovery(accountManagement, {
        idSiswa:this.props.idSiswa, idSekolah:this.props.idSekolah, requestId:this.state.requestId
      });
      if (!this._unmounted) {
        this.setState({receipt:{requestId:receipt.requestId, status:receipt.status, sessionsRevoked:receipt.sessionsRevoked === true}, password:receipt.password, uncertain:false,
          message:'Sandi berhasil dibuat. Serahkan langsung kepada pemilik akun. Setelah ditutup, sandi tidak dapat ditampilkan ulang.'});
        this._hideTimer = setTimeout(() => {if (!this._unmounted) this.setState({password:null, visible:false});}, 5*60*1000);
      }
    } catch (error) {
      if (!this._unmounted) this.setState({message:recoveryFailure(error), uncertain:!recoveryReloadRequired(error), reloadRequired:recoveryReloadRequired(error)});
    } finally {
      this._pending = false;
      if (!this._unmounted) this.setState({pending:false});
    }
  };
  check = async () => {
    if (this._pending || !this.state.requestId || this.state.reloadRequired) return;
    this._pending = true; this.setState({pending:true, password:null, visible:false});
    try {
      const receipt = await checkRecovery(accountManagement, this.state.requestId);
      if (!this._unmounted) this.setState({receipt, uncertain:false,
        message:'Reset telah selesai. Sandi hanya diserahkan pada respons pertama. Jika sandi hilang, tutup lalu buat reset baru dengan sengaja setelah satu menit.'});
    } catch (error) {
      if (!this._unmounted) this.setState({message:recoveryFailure(error), uncertain:true});
    } finally {
      this._pending = false; if (!this._unmounted) this.setState({pending:false});
    }
  };
  render() {
    if (this.props.canRecover === false) return null;
    const {open,pending,message,requestId,password,visible,receipt,uncertain,reloadRequired} = this.state;
    return <React.Fragment>
      <Button type="button" size="sm" variant="outline-primary" onClick={this.open}>Reset Password</Button>
      <Modal show={open} onHide={this.close} backdrop="static" keyboard={!pending} aria-labelledby="recovery-title">
        <Modal.Header><Modal.Title id="recovery-title">Pulihkan sandi siswa</Modal.Title></Modal.Header>
        <Modal.Body>
          <p>Akun: <strong>{this.props.username || 'Siswa yang dipilih'}</strong></p>
          {!receipt && <p>Pastikan identitas siswa sudah benar. Tindakan ini mengganti sandi dengan sandi acak baru. Sandi lama tidak dapat ditampilkan.</p>}
          {receipt && <p>{receipt.sessionsRevoked === true ? 'Sesi login lama telah dicabut. Siswa harus masuk ulang dengan sandi baru.' : 'Sesi yang sudah masuk tetap berlaku hingga berakhir.'} Aplikasi belum mewajibkan ganti sandi setelah reset.</p>}
          {message && <Alert variant={receipt ? 'success' : 'info'} role="status">{message}</Alert>}
          {password && <div>
            <label htmlFor="recovery-password">Sandi baru (tampilan dibersihkan setelah 5 menit)</label>
            <input id="recovery-password" className="form-control" type={visible ? 'text' : 'password'} readOnly value={password} autoComplete="off" spellCheck="false" />
            <Button type="button" variant="link" onClick={() => this.setState({visible:!visible})}>{visible ? 'Sembunyikan sandi' : 'Tampilkan sandi'}</Button>
          </div>}
          {requestId && <p style={{overflowWrap:'anywhere'}}>Receipt: <code>{requestId}</code></p>}
          {uncertain && <p>Permintaan tidak dikirim ulang otomatis. Periksa hasil dengan receipt yang sama.</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="secondary" disabled={pending} onClick={this.close}>Tutup</Button>
          {uncertain && !reloadRequired && <Button type="button" disabled={pending} onClick={this.check}>Periksa hasil</Button>}
          {!receipt && !uncertain && !reloadRequired && <Button type="button" disabled={pending || !requestId} onClick={this.create}>{pending ? 'Memproses...' : 'Buat sandi baru'}</Button>}
        </Modal.Footer>
      </Modal>
    </React.Fragment>;
  }
}
export default StudentPasswordRecovery;
